import {
  logoPath as logoPathRaw,
  logoViewBox as logoViewBoxRaw,
  wordmarkPaths as wordmarkPathsRaw,
  wordmarkViewBox as wordmarkViewBoxRaw,
} from '@x9/brand-assets/logo-data';

const logoPath = logoPathRaw as string;
const logoViewBox = logoViewBoxRaw as string;
const wordmarkPaths = wordmarkPathsRaw as string[];
const wordmarkViewBox = wordmarkViewBoxRaw as string;

type Props = {
  className?: string;
  title?: string;
  /** Mark-only icon, or full horizontal wordmark (same art as native PDF reports). */
  variant?: 'mark' | 'wordmark';
};

export default function X9Logo({ className, title, variant = 'mark' }: Props) {
  const isWordmark = variant === 'wordmark';

  return (
    <svg
      viewBox={isWordmark ? wordmarkViewBox : logoViewBox}
      className={`fill-current ${className ?? ''}`}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      {isWordmark ? (
        wordmarkPaths.map((d) => <path key={d.slice(0, 24)} d={d} />)
      ) : (
        <path d={logoPath} />
      )}
    </svg>
  );
}
